import { useState, useEffect, useContext, createContext } from 'react'
import { useLocation } from 'react-router-dom';

export const AuthContext = createContext(null)

export const AuthContextProvider = (props: any) => {
  const [token, setToken] = useState<string|null>()
  const [error, setError] = useState()
  const [axiosInstance, setAxiosInstance] = useState<any>()
  const location = useLocation()
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const token = localStorage.getItem('loginToken');
    setToken(token);

    setLoading(false)
  }, [location]);

  return <AuthContext.Provider value={{ token, loading, error, axiosInstance }} {...props} />
}

export const useAuthState = () => {
  const auth: any = useContext(AuthContext)
  return { ...auth, isLoading: auth?.loading, isAuthenticated: auth?.token != null }
}
